// extracted by mini-css-extract-plugin
export default {"move-in-right":"oUwq83","moveInRight":"oUwq83","move-in-left":"VfkS3t","moveInLeft":"VfkS3t"};